import { useSort } from 'libs/searchspring/hooks/useSort'
import { FilterCollapse } from 'libs/searchspring/components/collection/filters/FilterCollapse'

export function FilterSort() {
  const { sorts, activeSort, handleSort, resetSort } = useSort()

  const activeSortLabel = activeSort
    ? sorts.find(sort => sort.value === activeSort)?.label
    : 'Recommended'

  return (
    <FilterCollapse label="Sort By" activeFilterLabel={activeSortLabel} data-ui="visible">
      <div className="flex flex-col gap-y-1.5">
        <div className="flex items-center gap-x-0.5 w-fit cursor-pointer">
          <input
            id={'sort__default'}
            className="field-radio"
            type="radio"
            value='default'
            name="sort"
            onClick={() => resetSort()}
            checked={!activeSort}
            aria-label="Recommended"
          />
          <label for={'sort__default'} className="paragraph-xs whitespace-nowrap cursor-pointer">
            Recommended
          </label>
        </div>
        {sorts?.map((sort) => (
          <div className="flex items-center gap-x-0.5 w-fit cursor-pointer" key={sort.value}>
            <input
              id={`sort__${sort.value}`}
              className="field-radio"
              type="radio"
              value={sort.value}
              name="sort"
              onClick={() => handleSort(sort.value)}
              checked={activeSort === sort.value}
              aria-label={sort.label}
            />
            <label for={`sort__${sort.value}`} className="paragraph-xs whitespace-nowrap cursor-pointer">
              {sort.label}
            </label>
          </div>
        ))}
      </div>
    </FilterCollapse>
  )
}
